// /src/caminhoApi.js

//Servidor Tunnel (players online) port 5000
//export const IP5000 = 'http://192.168.0.9:5000';

//koyed
//export const IP5000 = 'https://provincial-pietra-tibia-guild-monitor-43133650.koyeb.app';

//Fly
export const IP5000 = 'https://puzzled-leona-tibia-guild-monitor-cf6a69b8.koyeb.app';
//export const IP5000 = 'revoked';


// Render
export const IP10000 = 'https://exp-info.onrender.com';

//Servidor Tunnel (info extra, login, logs, alertas, classificacoes, sem-guild) port 5001
//export const IP5001 = 'https://impossible-belicia-tibia-guild-monitor-9e5fc07d.koyeb.app';
//export const IP5001 = 'https://wiring-geo-peas-danny.trycloudflare.com';
//export const IP5001 = 'http://192.168.0.9:5001';

export const endpoints = {
  // Server Geral
  getOnlinePlayers: `${IP5000}/get-online-players/solidera-havera`,
  getHealth: `${IP5000}/health/solidera-havera`,

  //////////////////////////////////////
  // Server
  alertasEndpoint: `${IP5000}/solidera-havera/alertas`,
  loginEndpoint: `${IP5000}/solidera-havera/login`,
  semGuildEndpoint: `${IP5000}/solidera-havera/sem-guild`,          
  classEndpoint: `${IP5000}/solidera-havera/classificacoes`,        
  guildMemberEndpoint: `${IP5000}/solidera-havera/guild-members`,

  extraInfoEndpoint: `${IP10000}/extra-info/solidera-havera`,
  //extraInfoEndpoint: '/extra-info-solidera-havera.json',
  
  // Admin
  backendBase: `${IP5000}/solidera-havera`,
  adminGetAll: `${IP5000}/solidera-havera/api/admin/get-all`,
  adminApprove: `${IP5000}/solidera-havera/api/admin/approve`,
  adminRevoke: `${IP5000}/solidera-havera/api/admin/revoke`,
  requestCount: `${IP5000}/solidera-havera/api/request-count`,
  checkAccess: `${IP5000}/solidera-havera/api/check-access`,
  requestAccess: `${IP5000}/solidera-havera/api/request-access`,
  saveContact: `${IP5000}/solidera-havera/api/save-contact`,

  //////////////////////////////////////

};